import { requests } from './agent'
import { HttpResponse } from '../models/http/Reponse'
import { Auction } from '../models/Auction'
import { Post } from '../models/Post'
import { FilterModes } from '../models/modes'

interface AuctionListResponse extends HttpResponse {
  data: Auction[]
}
interface PostListResponse extends HttpResponse {
  data: Post[]
}
interface FavoriteResponse extends HttpResponse {
  data: Post | Auction
}

const FavAuctions = {
  addFav: (id: string, type: FilterModes) =>
    requests.post<FavoriteResponse>('Favorite', { id: id, type: type }),
  list: () => requests.get<AuctionListResponse>('/Favorite'),
  listPosts: () => requests.get<PostListResponse>('Favorite/posts'),
  remove: (id: string, isAuction: boolean) =>
    requests.del<HttpResponse>(`Favorite/${id}?isAuction=${isAuction}`),
}

export default FavAuctions
